
<template  minapp='mpx' xlang='wxml'>
  <view
    class="login-drawer-button-container"
    bindtap="goToPage"
  >
    <view class="button-title">
      <image
        class="button-title-icon"
        wx:class="{{ isExemption && 'exemption' }}"
        src="{{iconUrl}}"
      />
      <view class="button-title-text" >
        {{ buttonTitle }}
      </view>
      <image
        wx:if="{{isExemption}}"
        class="button-title-rule"
        src="{{ruleUrl}}"
        catchtap="goToRule"
      />
    </view>
    <view class="button-description" >
      {{ descriptionText }}
    </view>
    <view class="recommend" wx:if="{{!isExemption}}">推荐</view>
    <view class="coupon" wx:if="{{couponDesc}}">{{couponDesc}}</view>
  </view>
</template>

<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'
  import { DeadLineList } from '@/utils/constants'
  import store from '@/store'
  import { getFinalPrice } from '@/utils/money'
  import { debounce } from '@/utils'
  import { goTo } from '@didi/webx-js'

  createComponent({
    props: {
      //1免登 0正常登录
      buttonType: {
        type: Number,
        value: 0,
      },
      amount:{
        type: Number,
        value: 0,
      },
    },
    attached() {},
    computed: {
      isExemption() {
        return this.buttonType === 1
      },
      iconUrl() {
        return this.isExemption
          ? 'https://img-hxy021.didistatic.com/static/starimg/img/imrDupSkvY1693636652464.png'
          : 'https://ut-static.udache.com/webx/sfc/GwZUkdktsYYACngamynO3.png'
      },
      buttonTitle() {
        return this.isExemption ? '免登录购票' : '登录12306'
      },
      descriptionText() {
        return this.isExemption ? '便携购票 +10元/人' : '官方直购'
      },
      couponDesc(){
        let _m = this.amount && getFinalPrice(this.amount)
        return _m ?  `${_m}元优惠券` : '' 
      }
    },
    data: {
      ruleUrl:"https://ut-static.udache.com/webx/sfc/WkhIy03P_zgw1HjsoPBZX.png"
    },
    methods: {
       ...store.mapMutations({
        setMakeOrderLoginType: 'makeOrder.setMakeOrderLoginType',
      }),
      closeLoginDrawer() {
        this.triggerEvent('close')
      },
      goToPage() {
        this.closeLoginDrawer()
        if(this.buttonType === 1){
          this.setMakeOrderLoginType(1)
          this.triggerEvent('submit')
        }
        else {
          this.triggerEvent('check')
        }
      },
      goToRule: debounce(
        function () {
          goTo({ url: 'https://v.didi.cn/3MeElxE' })
        },
        300,
        false
      )
    },
  })
</script>

<style lang='stylus' scoped>
  .login-drawer-button-container
    display flex
    flex-direction column
    width 163.5px
    height 70px
    justify-content center
    align-items center
    background #fff
    border-radius 16px
    color #fff
    box-sizing border-box
    border 1px solid #CCCCCC
    position relative
    .button-title
      display flex
      height 16px
      line-height 16px
      font-family PingFangSC-Semibold
      font-size 16px
      margin-bottom 6px
      align-items center
      .button-title-icon
        height 16px
        width 14px
        margin-right 5px
        &.exemption
          height 16px
          width 11.5px
          margin-right 6px
      .button-title-text
        color #333
      .button-title-rule
        width 16px
        height 16px
    .button-description
      font-family PingFangSC-Regular
      font-size 10px
      line-height 10px
      color #999
    .recommend
      padding 3px 5px 4px 5px
      border-radius 0 10px 0 10px
      background #338FFF
      font-family PingFang SC
      font-size 10px
      font-weight normal
      line-height 10px
      text-align center
      letter-spacing 0px
      color #FFFFFFx
      position absolute
      top -1px
      right -1px
    .coupon
      margin-top 6px
      box-sizing border-box
      border 0.5px solid #FFBC91
      padding 1.5px
      font-family PingFang SC
      font-size 9px;
      font-weight normal
      line-height 9px
      letter-spacing 0px
      color #FF6400
</style>

<script name='json'>
  module.exports = {
    component: true,
    usingComponents: {},
  }
</script>